import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import EditView from "../views/EditView.vue";
import AddView from "../views/AddView.vue";
import LoginView from "../views/LoginView.vue";
import store from "../store";
import AuthService from "@/services/auth_service";
import { Roles } from "@/models/user";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { public: true },
  },
  {
    path: "/",
    name: "fabrics",
    component: () => import(/* webpackChunkName: "fabrics" */ "../views/FabricsView.vue"),
  },
  {
    path: "/edit",
    name: "edit",
    props: true,
    component: EditView,
  },
  {
    path: "/new",
    name: "new",
    props: true,
    component: AddView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const authService = new AuthService();

// The entire app is admin-gated. On every protected navigation we verify the
// session against the API, hydrate the store, and reject non-admins.
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    next();
    return;
  }

  // Use cached state when we already know the user is an admin this session.
  if (store.getters.isLoggedIn && store.getters.isAdmin) {
    next();
    return;
  }

  try {
    const user = await authService.checkAuth();
    if (user.role !== Roles.Admin) {
      await store.dispatch("clearAuth");
      next({ name: "login", query: { notice: "This tool is restricted to admins only." } });
      return;
    }
    await store.dispatch("setAuth", user);
    next();
  } catch (err) {
    await store.dispatch("clearAuth");
    // Unauthenticated → in-app login form. The login form also offers a link to
    // the central tt-frankford-auth portal (VUE_APP_LOGIN_URL) for SSO.
    next({ name: "login", query: { redirect: to.fullPath } });
  }
});

export default router;
